import { ModalController } from '@ionic/angular';
import { EventEmitter, Injectable } from '@angular/core';
import { I18nService } from '@core/services';
import { ComponentEnum } from '@core/enums';
import { selectAccountSlug, selectLanguaje } from '@store/selectors';
import { Store } from '@ngrx/store';
import { IAbstractPresenter, ILanguageObject } from '@core/interfaces';
import { ITermsConditionsComponent, ITermsConditionsPresenter } from './interfaces';
import { SelectedTabEnum } from './enums';
import { takeUntil } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TermsConditionsPresenter
	extends IAbstractPresenter<ITermsConditionsComponent>
	implements ITermsConditionsPresenter
{
	cancelTxt: string = 'Cancel';
	selectedTab: SelectedTabEnum = SelectedTabEnum.TERMS;
	translations: ILanguageObject;
	accountSlug: string | null = null;

	showAcceptButtons: boolean = true;
	accepted: EventEmitter<void> = new EventEmitter<void>();
	declined: EventEmitter<void> = new EventEmitter<void>();

	constructor(
		private modalCtrl: ModalController,
		private store: Store,
		private i18nService: I18nService
	) {
		super();
		this.translations = this.i18nService.getTranslations(ComponentEnum.TermsConditions);
	}

	dispatchActions(): void {}

	suscribeObservers(): void {
		this.store.select(selectLanguaje).subscribe(lang => {
			this.view.translations = this.i18nService.getTranslations(ComponentEnum.TermsConditions, lang);
		});

		this.store
			.select(selectAccountSlug)
			.pipe(takeUntil(this.destroy$))
			.subscribe(accountSlug => (this.view.accountSlug = accountSlug));
	}

	onTabChanged(event: string): void {
		if (this.view) {
			this.view.selectedTab = event as SelectedTabEnum;
		}
	}

	onAccept(): void {
		if (this.view) {
			this.view.accepted.emit();
			this.dismiss('accepted');
		}
	}

	onDecline(): void {
		if (this.view) {
			this.view.declined.emit();
			this.dismiss();
		}
	}

	dismiss(role?: string): void {
		this.modalCtrl.dismiss(null, role);
	}
}
